module.exports = new __parcel__URL__("bossfight_damage_button.997dff7d.png").toString();